import { Loadable } from 'foundations-components/transitional/utils/Loadable';
const AsyncContactLimitBanner = Loadable({
  loader: () => import( /* webpackChunkName: "contact-limit-banner" */'./ContactLimitBanner')
});
export default AsyncContactLimitBanner;